import { render } from "./AddNewUser.vue?vue&type=template&id=1a37ebce&scoped=true"
import script from "./AddNewUser.vue?vue&type=script&lang=js"
export * from "./AddNewUser.vue?vue&type=script&lang=js"

import "./AddNewUser.vue?vue&type=style&index=0&id=1a37ebce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a37ebce"]])

export default __exports__